/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  path {
    &.white {
      fill: ${theme.color.themeTxt};
    }
    &.yellow {
      fill: ${theme.color.yellow};
    }
    &.none {
      fill: none;
    }
  }
`

export default class TodayTabIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="58.39" height="49.672" viewBox="0 0 58.39 49.672" css={Color}>
          <g id="그룹_4192" transform="translate(-786.79 -641.525)">
            <g id="그룹_4208" data-name="그룹 4208">
              <path id="패스_3969" className="white" data-name="패스 3969" d="M844.5,664.8l-.8-.3-.9-.3a7.386,7.386,0,0,0,1.7-2.5,7.712,7.712,0,0,0-1.1-8.1l-.4-.6-.9.1a7.952,7.952,0,0,0-6.7,4.7,7.826,7.826,0,0,0,.9,7.8c-.2.2-.4.3-.6.5a8.083,8.083,0,0,0-2.6,6.7,1.95,1.95,0,0,0-.8.1,8.015,8.015,0,0,0-6.3,5.2l-.3.8.5.7a8.052,8.052,0,0,0,6.4,3.2,4.87,4.87,0,0,0,1.2-.1,8.015,8.015,0,0,0,6.3-5.2l.3-.8-.5-.7a4.354,4.354,0,0,0-.6-.7,9.044,9.044,0,0,0,3.2-1.7,7.946,7.946,0,0,0,2.4-7.8Zm-8.2,7.4a4.627,4.627,0,0,1,1.5-3.7,4.568,4.568,0,0,1,3.9-1.1,4.627,4.627,0,0,1-1.5,3.7A5.015,5.015,0,0,1,836.3,672.2Zm2.3-9.1a4.664,4.664,0,0,1-.1-4,4.552,4.552,0,0,1,3-2.6,4.664,4.664,0,0,1,.1,4A5.141,5.141,0,0,1,838.6,663.1Zm-2,14.1a4.95,4.95,0,0,1-3.3,2.3,4.422,4.422,0,0,1-3.8-1.2,4.95,4.95,0,0,1,3.3-2.3A4.422,4.422,0,0,1,836.6,677.2Z" fill="#eee" />
              <path id="패스_3970" className="white" data-name="패스 3970" d="M799.8,672.8c-.3,0-.6-.1-.8-.1a7.8,7.8,0,0,0-2.6-6.7c-.2-.2-.4-.3-.6-.5a7.917,7.917,0,0,0-5.9-12.5H789l-.5.7a8.157,8.157,0,0,0-1.1,8.1,7.386,7.386,0,0,0,1.7,2.5,3.178,3.178,0,0,0-.9.3l-.8.3-.2.8a7.815,7.815,0,0,0,2.4,7.8,7.625,7.625,0,0,0,3.2,1.7c-.2.2-.4.5-.6.7l-.5.7.3.8a7.842,7.842,0,0,0,6.3,5.2,4.87,4.87,0,0,0,1.2.1,8.2,8.2,0,0,0,6.4-3.2l.5-.7-.3-.8A8.2,8.2,0,0,0,799.8,672.8Zm2.8,5.5a4.859,4.859,0,0,1-3.8,1.2,4.647,4.647,0,0,1-3.3-2.3,4.745,4.745,0,0,1,3.8-1.2A4.647,4.647,0,0,1,802.6,678.3Zm-8.4-9.8a4.331,4.331,0,0,1,1.5,3.7,5.015,5.015,0,0,1-3.9-1.1,2.24,2.24,0,1,1,2.4-2.6Zm-3.8-8.1a4.664,4.664,0,0,1,.1-4,4.375,4.375,0,0,1,3,2.6,4.664,4.664,0,0,1-.1,4A4.552,4.552,0,0,1,790.4,660.4Z" fill="#eee" />
            </g>
            <g id="그룹_4209" data-name="그룹 4209">
              <path id="패스_3971" className="yellow" data-name="패스 3971" d="M829.4,650.6a3.492,3.492,0,0,0-2.4-1h-6l-1.8-5.7a3.445,3.445,0,0,0-2.2-2.2,3.4,3.4,0,0,0-4.3,2.2l-1.8,5.7h-6a3.5,3.5,0,0,0-2.8,1.4,3.165,3.165,0,0,0-.6,2.5,3.279,3.279,0,0,0,1.4,2.2l4.8,3.5-1.8,5.7a3.32,3.32,0,0,0,1.2,3.8,3.456,3.456,0,0,0,4,0l4.8-3.5,4.8,3.5h0a3.605,3.605,0,0,0,2,.6,2.957,2.957,0,0,0,1-.2,3.4,3.4,0,0,0,2.2-4.3l-1.8-5.7,4.8-3.5a3.368,3.368,0,0,0,1.4-2.8A2.557,2.557,0,0,0,829.4,650.6Z" fill="#ffce00" />
            </g>
            <g id="그룹_4193" transform="translate(795.664 667.297)">
              <g id="사각형_1833">
                <g id="그룹_4210" data-name="그룹 4210">
                  <path id="패스_3972" className="none" data-name="패스 3972" d="M10.3,8.4H30.1a2.946,2.946,0,0,1,3,3v9.5a2.946,2.946,0,0,1-3,3H10.3a2.946,2.946,0,0,1-3-3V11.4A3.009,3.009,0,0,1,10.3,8.4Z" fill="none" />
                </g>
                <g id="그룹_4211" data-name="그룹 4211">
                  <path id="패스_3973" className="white" data-name="패스 3973" d="M30.1,23.9H10.3a2.946,2.946,0,0,1-3-3V11.4a2.946,2.946,0,0,1,3-3H30.1a2.946,2.946,0,0,1,3,3v9.5A3.009,3.009,0,0,1,30.1,23.9ZM10.3,11.4h0v9.5H30.1V11.4Z" fill="#eee" />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </Fragment>
    )
  }
}
